/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 70d2f0aa (Mon Feb 23 19:51:14 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface SafetyTrainingWebhookRequestBody
 */
export interface SafetyTrainingWebhookRequestBody {
  /**
   * Unique identifier of the user in Ministry Safe.
   * @type string
   * @memberof SafetyTrainingWebhookRequestBody
   */
  userId: string
  /**
   * Unique identifier of the user in our system.
   * @type string
   * @memberof SafetyTrainingWebhookRequestBody
   */
  externalId: string
  /**
   * Score of the safety training.
   * @type number
   * @memberof SafetyTrainingWebhookRequestBody
   */
  score: number
  /**
   * Date when the safety training was completed.
   * @type Date
   * @memberof SafetyTrainingWebhookRequestBody
   */
  completeDate: Date
  /**
   * Survey code of the safety training.
   * @type string
   * @memberof SafetyTrainingWebhookRequestBody
   */
  surveyCode: string
  /**
   * URL to the certificate of completion.
   * @type string
   * @memberof SafetyTrainingWebhookRequestBody
   */
  certificateUrl: string
  /**
   * Indicates if the user is a winner of the safety training.
   * @type boolean
   * @memberof SafetyTrainingWebhookRequestBody
   */
  winner?: boolean
}

export function SafetyTrainingWebhookRequestBodyFromJSON(
  json: any
): SafetyTrainingWebhookRequestBody {
  return SafetyTrainingWebhookRequestBodyFromJSONTyped(json, false)
}

export function SafetyTrainingWebhookRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SafetyTrainingWebhookRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userId: json['user_id'],
    externalId: json['external_id'],
    score: json['score'],
    completeDate: new Date(json['complete_date']),
    surveyCode: json['survey_code'],
    certificateUrl: json['certificate_url'],
    winner: !exists(json, 'winner') ? undefined : json['winner'],
  }
}

export function SafetyTrainingWebhookRequestBodyToJSON(
  value?: SafetyTrainingWebhookRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    user_id: value.userId,
    external_id: value.externalId,
    score: value.score,
    complete_date: value.completeDate.toISOString(),
    survey_code: value.surveyCode,
    certificate_url: value.certificateUrl,
    winner: value.winner,
  }
}
